import { motion } from "framer-motion";
import Container from "Components/Container/Container";
import {
  FilmSlate,
  GraduationCap,
  Clock,
  DeviceMobile,
  Certificate,
  Globe,
  Lightning,
  BookOpen,
  Users,
  Star,
  Play,
  Shield,
} from "@phosphor-icons/react";

const ICON_MAP = {
  film: FilmSlate,
  "graduation-cap": GraduationCap,
  clock: Clock,
  devices: DeviceMobile,
  certificate: Certificate,
  globe: Globe,
  lightning: Lightning,
  book: BookOpen,
  users: Users,
  star: Star,
  play: Play,
  shield: Shield,
};

const PlatformExperience = ({ data }) => {
  if (!data) return null;

  const { sectionTitle, tagline, stats, cards } = data;

  return (
    <section>
      <Container>
        {/* Stats Bar */}
        {stats?.length > 0 && (
          <div className={`grid gap-4 lg:gap-0 bg-grey/50 border border-gray-700/50 rounded-2xl p-4 sm:p-6 lg:p-8 ${
            stats.length <= 2 ? "grid-cols-1 sm:grid-cols-2" :
            stats.length === 3 ? "grid-cols-1 sm:grid-cols-3" :
            "grid-cols-2 sm:grid-cols-2 md:grid-cols-4"
          }`}>
            {stats.map((stat, i) => (
              <div
                key={i}
                className={`text-center ${
                  i < stats.length - 1 ? "sm:border-e sm:border-gray-700" : ""
                }`}
              >
                <p className="text-3xl lg:text-4xl font-extrabold text-white leading-none">
                  {stat.value}
                </p>
                <p className="text-sm text-gray-400 mt-1">{stat.label}</p>
              </div>
            ))}
          </div>
        )}

        {/* Section Title + Tagline */}
        {(sectionTitle || tagline) && (
          <div className="text-center mt-section-gap lg:mt-section-gap-lg mb-section-title-gap lg:mb-section-title-gap-lg">
            {sectionTitle && (
              <h2 className="text-2xl lg:text-4xl font-bold text-white">
                {sectionTitle}
              </h2>
            )}
            {tagline && (
              <p className="text-gray-400 mt-3 max-w-2xl mx-auto text-sm lg:text-base">
                {tagline}
              </p>
            )}
          </div>
        )}

        {/* Differentiator Cards */}
        {cards?.length > 0 && (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {cards.map((card, i) => {
              const IconComponent = ICON_MAP[card.icon] || BookOpen;
              return (
                <motion.div
                  key={i}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.4, delay: i * 0.1 }}
                  className="bg-grey/60 border border-gray-700/40 rounded-2xl p-6 lg:p-7 hover:border-primary/30 transition-colors duration-300"
                >
                  <div className="w-11 h-11 rounded-xl bg-primary/10 flex items-center justify-center mb-5">
                    <IconComponent size={22} weight="duotone" className="text-primary" />
                  </div>
                  <h3 className="text-lg font-bold text-white mb-2">
                    {card.title}
                  </h3>
                  <p className="text-sm text-gray-400 leading-relaxed">
                    {card.text}
                  </p>
                </motion.div>
              );
            })}
          </div>
        )}
      </Container>
    </section>
  );
};

export default PlatformExperience;
